import { extend, override } from 'flarum/common/extend';
import { isNecrobumping } from '../utils/necrobumping';
import InactiveDiscussionAlert from '../components/InactiveDiscussionAlert';

// Extend ReplyComposer attrs type to include discussion

export default function extendReplyComposer() {
  override('flarum/forum/components/ReplyComposer', 'view', function (orig) {
    const attrs = this.attrs;
    const necrobumpingDays = isNecrobumping(attrs.discussion);
    attrs.disabled = attrs.disabled || !!necrobumpingDays && !this.composer.fields.fofNecrobumping;
    return orig.call(this);
  });
  extend('flarum/forum/components/ReplyComposer', 'headerItems', function (items) {
    const attrs = this.attrs;
    const days = isNecrobumping(attrs.discussion);
    if (days) {
      items.add('fof-necrobumping', m(InactiveDiscussionAlert, {
        days: days,
        discussion: attrs.discussion,
        checked: !!this.composer.fields.fofNecrobumping,
        set: v => this.composer.fields.fofNecrobumping = v
      }));
    }
  });
  extend('flarum/forum/components/ReplyComposer', 'data', function (data) {
    data['fof-necrobumping'] = this.composer.fields.fofNecrobumping;
  });
}
flarum.reg.add('fof-prevent-necrobumping', 'forum/extenders/extendReplyComposer', extendReplyComposer);